module.exports = __webpack_public_path__ + "media/img/avatars/default-afca899e7d053416b69d84eadce805a8.jpg";